function agentTransferKey(){
  const lsTimestamp = $('.agent-float-transfer-timestamp').data('local-storage-timestamp')
  return `agent-float-transfer-data-${lsTimestamp}`
}

function getAgentId() {
  return $('#agent-dropdown option:selected').val()
}

function getAgentCodeId() {
  return $('#agent-dropdown option:selected').data('agent-code-id')
}

function getAgentName() {
  return $('#agent-dropdown option:selected').data('agent-name')
}

function getTillNumber() {
  return $('#agent-dropdown option:selected').data('agent-number')
}

function floatAmount() {
  return removeCommas($('#float-amount').val())
}

function addAgentFloat() {
  $("#add-agent-float").click(function () {

    const agentId = getAgentId()
    const agentCodeId = getAgentCodeId()
    const agentName = getAgentName()
    const tillNumber = getTillNumber()
    const amount = floatAmount()
    const uniquekey = agentId

    if ($("#" + uniquekey).length > 0) {
      toastNotification('error', `Already added`);
    } else if (isNaN(amount) || allWhiteSpaces(amount) ) {
      toastNotification('error', 'Amount is not valid');
    } else {

      const agentFloatItem = {
        key: agentId,
        agent_id: agentId,
        agent_code_id: agentCodeId,
        agent_name: agentName,
        till_number: tillNumber,
        amount: amount
      }

      storeItemInLocalStorage(agentFloatItem, agentTransferKey())
      setAgentFloatRows()
    }
  });
}

function setInitialAgentFloatData(view = 'edit', agentFloatTransferAttr) {
  localStorage.removeItem(agentTransferKey())
  let agentFloatTransferId = $('#agent-float-transfer-form input[name="agent_float_transfer[agent_float_transfer_id]"').val()

  if (view === 'index') {
    agentFloatTransferId = agentFloatTransferAttr
  }
  const action = $('#agent-float-transfer-form input[name="agent_float_transfer[transfer_action]"').val()

  if (view === 'edit' && (action === 'create' || agentFloatTransferId === null || agentFloatTransferId === undefined)) {
    return
  }

  $.ajax({
    type: "post",
    url: `/agent_details/${agentFloatTransferId}`,
    dataType: "json",
    headers: {
      'X-CSRF-Token': csrfToken()
    },
    success: function (data) {
      console.log(data)
      localStorage.setItem(agentTransferKey(), JSON.stringify(data))
      setAgentFloatRows()
    },
    error: function (data) {
      disableSubmit()
      console.log('An error occurred.');
      console.log(data);
    },
  });
}

function setAgentFloatRows() {
  const agentFloatData = JSON.parse(localStorage.getItem(agentTransferKey()))
  console.log(agentFloatData)

  if (agentFloatData === null || agentFloatData === undefined) {
    console.log('ERROR')
    return
  }

  // remove current content
  $(".agent-float-data").empty()

  // set data rows
  $.each(agentFloatData, function (key, agentFloatDetails) {
    const agentName = agentFloatDetails.agent_name
    const tillNumber = agentFloatDetails.till_number
    const amount = agentFloatDetails.amount
    const elementId = agentFloatDetails.agent_id

    $(".agent-float-data").append(
      `<tr id='${elementId}'>
        <td class="agent-name" >${agentName}</td>
        <td class="till-number text-right">${tillNumber}</td>
        <td class="total-amount text-right">${numberWithCommas(amount)}</td>
        <td>
          <a href='javascript:;' class='remove-agent-float' data-agent-id='${elementId}'
          >
            <i class='fa fa-minus-circle' style='font-size: 14px; margin-left: 15px; color: red'></i>
          </a>
        </td>
      </tr>`
    )
  })

  const totalAmount = calculateTotalAmount()

  // set total row
  $(".agent-float-data").append(
    `<tr id='agent-float-data-total'>
      <td><strong>TOTAL</strong></td>
      <td></td>
      <td class='total-sale text-right'>
        <strong>${numberWithCommas(totalAmount)}</strong>
      </td>
      <td></td>
    </tr>`)

  $('input[name="agent_float_transfer[total]"]').val(totalAmount)

  // setTotalAmount();
  $('#float-amount').val('')
}

function calculateTotalAmount() {
  const data = JSON.parse(localStorage.getItem(agentTransferKey()))

  if (data === null || data === undefined) {
    console.log('ERROR')
    return 0
  }

  let totalAmount = Object.values(data).reduce(function (accumulator, curValue) {
    return accumulator + parseFloat(curValue.amount)
  }, 0)

  return totalAmount
}

function removeAgentFloat() {
  $("form").on('click', '.remove-agent-float', function () {
    const agentId = $(this).data('agent-id');
    const uniquekey = agentId

    toastNotification('info', 'Removed Item');
    removeItemFromLocalStorage(uniquekey, agentTransferKey())
    $(this).closest("tr").remove();
    setAgentFloatRows()
    $('#unit-cost-price').closest('.form-group').removeClass('has-success');

  });
}

function submitAgentFloat() {
  $('#submit-ajax-form-btn').click(function () {
    disableSubmit()

    let errorString = [];
    const dateOfTransfer = $('#agent-float-transfer-form input[name="agent_float_transfer[created_at]"]').val()
    const agentFloatData = JSON.parse(localStorage.getItem(agentTransferKey()))


    if (JSON.stringify(agentFloatData) === '{}' || JSON.stringify(agentFloatData) === 'null') {
      errorString.push('No Data detected, refresh and try again');
    }

    if (isEmpty(dateOfTransfer)) {
      errorString.push('Transaction date cannot be blank');
    }

    if (errorString.length > 0) {
      toastNotification('error', errorString.join(','))
    } else {
      $('#spinner-modal').modal('show');

      const postUrl = $('#agent-float-transfer-form').attr('action')
      const redirectUrl = '/agent_float_transfers'
      const branchId = $('#agent-float-transfer-form input[name="agent_float_transfer[branch_id]"]').val()
      const description = $('#agent-float-transfer-form textarea[name="agent_float_transfer[description]"]').val()
      const cashSourceId = $(`select[name="agent_float_transfer[cash_source_id]"] option:selected`).val()
      const totalAmount = calculateTotalAmount()

      let action = "post"

      if ($('#agent-float-transfer-form input[name="agent_float_transfer[transfer_action]"').val() === 'update') {
        action = "patch"
      }

      $.ajax({
        type: action,
        url: postUrl,
        headers: {
          'X-CSRF-Token': csrfToken()
        },
        data: {
         agent_float_transfer: {
            branch_id: branchId,
            agent_float_data: agentFloatData,
            created_at: dateOfTransfer,
            description: description,
            cash_source_id: cashSourceId,
            total: totalAmount,
          }
        },
        dataType: "json",
        success: function (data) {
          localStorage.removeItem(agentTransferKey()) // clean up local storage
          window.location.replace(redirectUrl);
        },
        error: function (data) {
          disableSubmit()
          console.log('An error occurred.');
          console.log(data);
        },
      });
    }
  });
}


$(document).ready(function () {
  if ($('#agent-float-transfer-form').length > 0 && $('.amount-div').length > 0) {
    checkAmount('.amount', '.amount-div');

    setInitialAgentFloatData()
    addAgentFloat()
    removeAgentFloat()
    submitAgentFloat()
    clearFailedSubmit('#agent-float-transfer-form')
  }

  $('.view-agent-float-details').click(function () {
    const agentFloatTransferId = $(this).data('agent-float-transfer-id')
    setInitialAgentFloatData('index', agentFloatTransferId)
    localStorage.removeItem(agentTransferKey())
  })
});
